<template>
  <pt-policy-detail class="pt-policy-detail__withData" :policyDetail="policyDetail" :type="type" :typeName="typeName" :id="id"></pt-policy-detail>
</template>

<script>
import PtPolicyDetail from './index'
export default {
  name: 'pt-policy-detail__withData',
  components: {
    'pt-policy-detail': PtPolicyDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      apiUrl: '',
      typeName: '',
      policyDetail: {}
    }
  },
  methods: {
    // api调用的判断
    detailApiData () {
      switch (this.type) {
        case 'afterSales':
          this.apiUrl = 'afterSalesPolicyDetail'
          this.typeName = '售后政策'
          break
        case 'carriage':
          this.apiUrl = 'carriagePoliciesDetail'
          this.typeName = '运费规则'
          break
        case 'privacy':
          this.apiUrl = 'privacyPolicyDetail'
          this.typeName = '隐私条款'
          break
        default:
          console.log('尚未选择类型')
      }
    },
    // 获取政策详情
    getPolicyDetail () {
      this.$store.dispatch(this.apiUrl, this.id).then(res => {
        if (this.type === 'afterSales') {
          res.content = res.detail
          this.$delete(res, 'detail')
        }
        this.policyDetail = res
      }).catch(err => {
        this.$message.error(err || '获取' + this.typeName + '失败')
      })
    }
  },
  created () {
    this.detailApiData()
    this.getPolicyDetail()
  }
}
</script>
